import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOX_IMAGE, finalCtaPoints } from '../data/content';
export function FinalCta() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-16" data-id="element-67" data-mp="19fgudzs6f45c">
      <div className="mx-auto flex max-w-[700px] flex-col items-center text-center" data-id="element-68" data-mp="15ddhd6puzrhy">
        <h2 className="text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2rem]" data-id="element-69" data-mp="15fgiomwgp71z">
          One Last Question
        </h2>
        <p className="mt-4 max-w-[600px] text-[1rem] leading-relaxed text-white" data-id="element-70" data-mp="1eetpt8x45jjj">
          When you need to prepare your next Financial Literacy lesson, do you
          want to keep opening Google, searching for worksheets, looking for
          activities, creating slides, building assessments, writing answer
          keys, and trying to turn random resources into a lesson at the last
          minute...
        </p>
        <p className="mt-3 max-w-[600px] text-[1rem] leading-relaxed text-white" data-id="element-71" data-mp="1x64gpq2u9wbf">
          or would you rather open{' '}
          <strong className="font-extrabold text-white" data-id="element-72" data-mp="n7p8rlpkhpnh">
            ONE complete system and already have the lesson, worksheet,
            real-life activity, assessment, answer key, and yearly plan waiting
            for you?
          </strong>
        </p>
        <p className="mt-4 text-[1.1rem] font-extrabold uppercase leading-tight tracking-tight text-orange-500 sm:text-[1.3rem]" data-id="element-73" data-mp="123ws6jt5in1p">
          Choose. Open. Teach with confidence.
        </p>

        <img src={BOX_IMAGE} alt="The FINANCIAL LITERACY READY™ bundle" className="mt-7 w-full max-w-[300px]" width={1240} height={1240} data-id="element-74" data-mp="1b2ryrx03xz5j" />

        <p className="mt-7 flex items-center justify-center gap-2 text-[1.15rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.3rem]" data-id="element-75" data-mp="1ktmlf2h9n0ri">
          <ZapIcon className="h-5 w-5 fill-orange-500" aria-hidden="true" data-id="element-76" data-mp="1ttrqv72wfp31" />
          Financial Literacy Ready™
        </p>
        <p className="mt-2 text-balance text-[1.05rem] font-extrabold uppercase leading-tight tracking-tight text-white" data-id="element-77" data-mp="3qtvzej24veiv">
          The Complete Done-for-You Financial Literacy Teaching System
        </p>
        <p className="mt-2.5 text-[0.75rem] font-bold uppercase tracking-[0.2em] text-white/90 sm:text-[0.82rem]" data-id="element-78" data-mp="3imtwdm2wxca">
          Plan • Teach • Practice • Apply • Assess • Track
        </p>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[0.8rem] font-bold text-white" data-id="element-79" data-mp="df9agq7dh28i">
          {finalCtaPoints.map(point => <li key={point} className="flex items-center gap-1.5" data-id="element-80" data-mp="mggzeho00qpx">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" strokeWidth={3} aria-hidden="true" data-id="element-81" data-mp="mfxj15dzyae0" />
              {point}
            </li>)}
        </ul>

        <div className="mt-7 flex items-baseline justify-center gap-3" data-id="element-82" data-mp="2k68kf1f0lk2a">
          <span className="text-[1.5rem] font-bold text-white/70 line-through decoration-orange-500 decoration-2" data-id="element-83" data-mp="2k8bi87meshhk">
            $97 USD
          </span>
          <span className="text-[2.6rem] font-black leading-none tracking-tight text-orange-500 sm:text-[3rem]" data-id="element-84" data-mp="2e457ypst7os3">
            $27 <span className="text-[1.2rem] uppercase" data-id="element-85" data-mp="20bpcca28mt17">USD Today</span>
          </span>
        </div>

        <CtaButton label="Yes! I Want It Today" subLabel="Get the Complete System Now" className="mt-6 w-full max-w-[460px]" data-id="element-86" data-mp="25aae4dx51krr" />

        <p className="mt-4 text-[0.95rem] font-extrabold uppercase tracking-tight text-orange-500" data-id="element-87" data-mp="1vdx9wm3yvoir">
          One payment. No subscription. Instant access.
        </p>
      </div>
    </section>;
}